import React from 'react'
import { IonSplitPane, IonContent } from '@ionic/react'
import { useSelector } from 'react-redux'
import AddBilling from '../addBillingInfo/AddBillingInfo.component'
import { getBillingSelector } from '../selectors'
import { BillingConstants } from '../store/billing.constants'
import InsuranceInformationContent from '../../insuranceInformation/content/InsuranceInformation.content'
import RelationshipsAndGuarantorsContent from '../../relationshipsAndGuarantors/pageContent/RelationshipsAndGuarantors.content'
import PcsInformationTablet from '../../pcsInformation/pcsInformationContentTablet/PcsInformationTablet.component'
import AuthorizationInformationContent from '../../authorizationInformation/authorizationInformationContent/AuthorizationInformationContent.component'
import CmsInformation from '../../cmsInformation/cmsInformationContent/CmsInformationContent'
import PaymentInformation from '../../paymentInformation/paymentInformationContent/paymentInformation.content'

const BillingTablet: React.FC = () => {
  const { selectedOption } = useSelector(getBillingSelector)

  return (
    <>
      <IonSplitPane content-id='main-content' className='no-scroll'>
        <AddBilling />
        <IonContent id='main-content' color='light' fullscreen>
          {selectedOption === BillingConstants.INSURANCE_INFORMATION_OPTION && <InsuranceInformationContent />}
          {selectedOption === BillingConstants.RELATIONSHIPS_AND_GUARANTORS_OPTION && (
            <RelationshipsAndGuarantorsContent />
          )}
          {selectedOption === BillingConstants.PCS_INFORMATION_OPTION && <PcsInformationTablet />}
          {selectedOption === BillingConstants.AUTHORIZATION_INFORMATION_OPTION && <AuthorizationInformationContent />}
          {selectedOption === BillingConstants.CMS_INFORMATION && <CmsInformation />}
          {selectedOption === BillingConstants.PAYMENT_INFORMATION_OPTION && <PaymentInformation />}
        </IonContent>
      </IonSplitPane>
    </>
  )
}

export default BillingTablet
